var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 19.999,
    viewBox: "0 0 17.5 19.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Button_Icon",
    "data-name": "Button Icon",
    d: "M12.5,10.5a5,5,0,1,0-5-5A5,5,0,0,0,12.5,10.5Zm0-8.75A3.75,3.75,0,1,1,8.75,5.5,3.754,3.754,0,0,1,12.5,1.75Zm1.98,10.625H10.52a6.77,6.77,0,0,0-6.77,6.77A1.354,1.354,0,0,0,5.1,20.5H19.9a1.351,1.351,0,0,0,1.353-1.354A6.77,6.77,0,0,0,14.48,12.375Zm5.414,6.875H5.1a.1.1,0,0,1-.1-.105,5.526,5.526,0,0,1,5.52-5.52h3.957A5.527,5.527,0,0,1,20,19.145.105.105,0,0,1,19.895,19.25Z",
    transform: "translate(-3.75 -0.5)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.443efdb1273dc8a7c5a1aa405e86c8c8.svg";
export { ForwardRef as ReactComponent };